import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import fetchJsonWithFallback from "../../utils/fetchJsonWithFallback";
import { CDN_INCLUDES } from "../../utils/cdn";
import localTerms from "../../data/termsAndConditions.json";
import "./index.css";

function renderBlock(block, index) {
  switch (block.type) {
    case "paragraph":
      return <p key={index}>{parse(block.text)}</p>;
    case "list":
      return (
        <ul key={index}>
          {block.items.map((item, itemIndex) => (
            <li key={itemIndex}>{parse(item)}</li>
          ))}
        </ul>
      );
    default:
      return null;
  }
}

export default function TermsAndConditions() {
  const [terms, setTerms] = useState(localTerms);

  useEffect(() => {
    let isMounted = true;
    fetchJsonWithFallback(CDN_INCLUDES + "termsAndConditions.json", localTerms).then((data) => {
      if (isMounted) setTerms(data);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const { title, intro, sections } = terms;

  return (
    <React.Fragment>
      <div className="terms-page">
        <Container className="bg-text sm-width terms-container">
          <Row>
            <Col className="text-left">
              <div className="terms-card">
                {intro.map((paragraph, index) => (
                  <p key={index}>{parse(paragraph)}</p>
                ))}
                {sections.map((section) => (
                  <React.Fragment key={section.id}>
                    <h3>
                      <strong>{parse(section.heading)}</strong>
                    </h3>
                    {section.blocks.map((block, blockIndex) => renderBlock(block, blockIndex))}
                  </React.Fragment>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
